import type { User } from '@/types/user.type'

import { useState, useEffect } from 'react'
import { useBoolean } from '@/hooks/use-boolean'
import { useRouter } from '@/routes/hooks/use-router'
import { useAuthContext } from '@/contexts/auth-context/auth-provider'
import LoadingSection from '@/components/loading-indicator/loading-section'

import ProfileForm from '../profile-form'

// ----------------------------------------------------------------------

export default function ProfileFormView() {
  const router = useRouter()
  const loading = useBoolean(true)
  const [user, setUser] = useState<User | undefined>(undefined)
  const { user: authUser } = useAuthContext()

  const fetchUser = async () => {
    // For profile edit, always use current authenticated user
    setUser(authUser || undefined)
    loading.onFalse()
  }

  useEffect(() => {
    fetchUser()
  }, [authUser])

  return (
    <LoadingSection loading={loading.value}>
      <ProfileForm user={user || null} onCancel={() => router.back()} />
    </LoadingSection>
  )
}
